// extracted by mini-css-extract-plugin
export default {"reviews":"Review_reviews__A4udH","arrows":"Review_arrows__JuZdG","review-header":"Review_review-header__rhNyB","review-content":"Review_review-content__fZblJ"};